module.exports = __webpack_public_path__ + "static/media/logo-blue.710ccb37.png";